import React, { useEffect } from 'react';
import Intl from '@fx-ui/intl';
import { Button } from '@fx-ui/fine-design';
import {
    get,
    getAvailablePersonaData,
    getPersonaCollectAvailableFields,
    isEmpty,
    size,
    tracker,
    trim
} from '~/utils';
import { SuiteId, TRACKER, UGC_MAX_LENGTH } from '~/constants';
import { PersonaInfo, PersonaLabel } from '~/interfaces';
import PersonaCollect from '../persona-collect';
import Nickname from '../persona-collect/components/nickname';
import Phone from '../persona-collect/components/phone';
import Role from '../persona-collect/components/role';
import Referrer from '../persona-collect/components/referrer';
import { isOtherTag } from '../../utils/register';
import { updatePersonaInfo } from '~/request/persona';

interface UserPersonaCollectProps {
    personaInfo?: PersonaInfo;
    personaLabel?: PersonaLabel;
    suiteId?: SuiteId;
    setPersonaInfo: (action: (prevState: PersonaInfo) => PersonaInfo) => void;
    onComplete: () => void;
}

const { USER_NICKNAME } = UGC_MAX_LENGTH.USER;

const UserPersonaCollect: React.FC<UserPersonaCollectProps> = (props) => {
    const { onComplete, personaInfo, personaLabel, suiteId, setPersonaInfo } = props;

    const { nickname, role, phone, refererOtherVal, referrers } = personaInfo || {};

    useEffect(() => {
        tracker(TRACKER.ARRIVE_PERSONAL_INFO);
    }, []);

    const isDisabled = () => {
        if (!personaLabel) {
            return true;
        }
        const availableFields = getPersonaCollectAvailableFields(personaLabel);
        return (
            isEmpty(nickname) ||
            size(trim(nickname)) > USER_NICKNAME ||
            (availableFields.job && isEmpty(role?.value)) ||
            (availableFields.referrer && isEmpty(referrers))
        );
    };

    const getReferrer = () => {
        if (isOtherTag(get(referrers, '0', ''))) {
            const temp = refererOtherVal
                ? get(referrers, '0') + '-' + refererOtherVal
                : get(referrers, '0');
            return [temp];
        } else {
            return referrers;
        }
    };

    const handleClick = () => {
        const availableFields = getPersonaCollectAvailableFields(personaLabel);
        tracker(TRACKER.SELF_PORTRAIT_COMPLETE, {
            nickname: nickname!,
            role: role?.value || '',
            refer: referrers?.join() || ''
        });
        const personaData = {
            phone,
            nickname,
            ...getAvailablePersonaData(availableFields, {
                referrer: getReferrer(),
                job: role?.value
            })
        };
        return updatePersonaInfo({
            data: personaData,
            tenantId: personaInfo?.tenantId,
            suiteId
        }).finally(() => {
            onComplete();
        });
    };

    return (
        <PersonaCollect
            className="fx-user-persona-collect"
            title={Intl.get('persona.header.welcome')}
            subTitle={Intl.get('persona.header.detail.welcome')}
            personaInfo={personaInfo}
            personaLabel={personaLabel}
            setPersonaInfo={setPersonaInfo}
        >
            <Nickname />
            <Phone />
            <Role />
            <Referrer />
            <Button
                className="enter-btn"
                type="primary"
                size="large"
                block
                disabled={isDisabled()}
                loadingWhenClick
                onClick={handleClick}
            >
                {Intl.get('receiver.enter.homepage')}
            </Button>
        </PersonaCollect>
    );
};

export default UserPersonaCollect;
